<template>
  <div
    v-if="route?.query?.biennialEntryId && appVariant === 'main' && biennialTitle"
    :class="$style.root"
  >
    {{ label }}
    {{ lowerCaseFirstCharacter($t('shared.relatedTo', {name: biennialTitle?.title })) }},
    <layout-animated-underline-component
      :to="{
        name: parentName
      }"
      :inverted="true"
    >
      {{ $t('shared.viewAll')?.toLowerCase() }}
    </layout-animated-underline-component>
  </div>
</template>

<script lang="ts" setup>
const appVariant = getAppVariant()
const route = useRoute()
const { query } = route
const { biennialEntryId } = query

const props = defineProps({
  label: {
    type: String
  },
  parentName: {
    type: String,
    default: 'news'
  },
})

const resultsAreFiltered = computed(() => {
  return biennialEntryId !== undefined && appVariant === 'main'
})

const { data: biennialData, execute: executeBiennialData } = useAsyncData(() => {
  return $fetch('/api/strapi-rest', { query: { path: queryBiennialEntryById(getPageQuery({id: biennialEntryId})) } })
}, {immediate: false})

const biennialTitle = computed(() => {
  return getFirstObject(biennialData.value?.data)
})

if (resultsAreFiltered.value) {
  executeBiennialData()
}

const lowerCaseFirstCharacter = (str => {
  if (!str) return str
  return str.charAt(0).toLowerCase() + str.slice(1)
})
</script>

<style module>
.root {
  composes: container caption font-size-small from global;

  padding: var(--padding--element);

  backdrop-filter: var(--backdrop-filter--dark);
  border-radius: var(--border-radius--default);

  margin-bottom: calc(var(--font-small--line-height) + (var(--font-small--line-height) - var(--unit--vertical)));
}
</style>
